import { createNumberFormatter } from '@dreryk/react-common';

import { getPreciseDosagePortionPrecision } from '~libs.shared.prescription';

const quantityLimitFormatter = createNumberFormatter({
   maximumFractionDigits: getPreciseDosagePortionPrecision(),
});

export const getFormattedQuantityLimit = (limit: number): string => {
   return quantityLimitFormatter(limit) ?? '';
};
